import Swal from 'sweetalert2';


export const handleSuccess = (titulo, texto) => {
  Swal.fire({
    title: titulo,
    text: texto,
    icon: 'success',
    confirmButtonText: 'Ok',
    confirmButtonColor: "green",
  });
};

export const handleError = (titulo, texto) => {
  Swal.fire({
    title: titulo,
    text: texto,
    icon: 'error',
    confirmButtonText: 'Cerrar',
    confirmButtonColor: "red",
  });
};